<template>
    <div>
        <div class="page-top mb-1 mb-3">
            <h1> Add Campus </h1>
        </div>
        <div class="global-main">
            <form id="campusForm" @submit.prevent="addFeeCampusData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label>Campus Type</label>
                        <select v-model="form.campus_type" name="campus_type" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('campus_type') }">
                            <option value="" selected>Select Campus Type</option>
                            <option value="OWNED">Owned</option>
                            <option value="FRANCHISE">Franchise</option>
                        </select>
                        <has-error :form="form" field="campus_type"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Name </label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Campus Code </label>
                        <input v-model="form.campus_code" type="text" name="campus_code" class="form-control" :class="{ 'is-invalid': form.errors.has('campus_code') }">
                        <has-error :form="form" field="campus_code"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Address </label>
                        <textarea v-model="form.address" name="address" class="form-control" :class="{ 'is-invalid': form.errors.has('address') }"></textarea>
                        <has-error :form="form" field="address"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Account Title </label>
                        <input v-model="form.account_title" type="text" name="account_title" class="form-control" :class="{ 'is-invalid': form.errors.has('account_title') }">
                        <has-error :form="form" field="account_title"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Account Number </label>
                        <input v-model="form.account_number" type="text" name="account_number" class="form-control" :class="{ 'is-invalid': form.errors.has('account_number') }">
                        <has-error :form="form" field="account_number"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Bank Customer Code </label>
                        <input v-model="form.bank_customer_code" type="text" name="bank_customer_code" class="form-control" :class="{ 'is-invalid': form.errors.has('bank_customer_code') }">
                        <has-error :form="form" field="bank_customer_code"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Status </label>
                        <select v-model="form.status" name="status" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                            <option value="" selected>Select Status</option>
                            <option value="ENABLED">Enabled</option>
                            <option value="DISABLED">Disabled</option>
                        </select>
                        <has-error :form="form" field="status"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/companies" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    campus_type : '',
                    name : '',
                    campus_code : '',
                    address : '',
                    account_title : '',
                    account_number : '',
                    bank_customer_code : '',
                    status : '',
                }),
            }
        },
        methods: {
            addFeeCampusData() {
                this.$Progress.start();
                this.form.post('api/addFeeCampus')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Campus created successfully'
                        });
                        this.$router.push('/feeCampus');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            getAddFeeCampusData(){
                this.$Progress.start();
                setTimeout(function(){
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                }.bind(this),300);
                this.$Progress.fail();
            },
        },
        created() {
            this.getAddFeeCampusData();
        },
    }
</script>
